import IFieldModel from "@mapmycustomers/shared/types/fieldModel/IFieldModel";

import getFieldModelByEntityType, {
  EntityTypeWithFieldModel,
} from "@app/util/fieldModel/getByEntityType";

import { getFieldEntityType } from "./getFieldEntityType";

export const getFieldByFilterName = (fieldFilterName: string, fieldModel: IFieldModel) => {
  let field = fieldModel.getByFilterName(fieldFilterName);

  let fieldEntityType: EntityTypeWithFieldModel | undefined;

  if (!field) {
    fieldEntityType = getFieldEntityType(fieldFilterName);
    if (fieldEntityType) {
      const actualFieldName = fieldFilterName.substring(fieldEntityType.length + 1);
      const fieldFieldModel = getFieldModelByEntityType(fieldEntityType!);
      field = fieldFieldModel.getByFilterName(actualFieldName);
    }
  }

  return { field, fieldEntityType };
};
